import React, { useEffect } from "react";
import { CustomForm, CustomInput } from "../../shared/Input/AllInputs";
import CustomImageInput from "../../shared/Input/CustomImageInput";
import PrimaryButton, { PrimaryButtonOutlined } from "../../shared/Button/PrimaryButton";
import StyleGuideContainer from "./StyleGuideContainer";

const StyleGuideForm = ({ type }) => {
    const { data, history, handleChange, setFormType, loading, addStyle } = StyleGuideContainer();

    useEffect(() => {
        setFormType(type);
    }, [type, setFormType]);

    return (
        <>
            <CustomForm style={type === "VIEW" ? { pointerEvents: "none" } : {}}>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <div className="flex col-8 align-items-center">
                        <CustomImageInput
                            col={5}
                            name="singleImage"
                            label="Image"
                            key="singleImage"
                            data={data}
                            editable={true}
                            onFilesChange={handleChange}
                        />
                        <CustomInput key="name" label="Name" name="name" data={data} onChange={handleChange} />
                        <CustomInput key="paragraph" label="Paragraph" name="paragraph" data={data} onChange={handleChange} />
                    </div>
                </div>
            </CustomForm>
            <div className="flex mb-3 justify-content-end">
                {type !== "VIEW" && (
                    <PrimaryButton
                        extraClassName="lg:w-3 w-6"
                        label={type === "EDIT" ? "Update Style" : "Add Style"}
                        loading={loading}
                        onClick={addStyle}
                    />
                )}
                <PrimaryButtonOutlined extraClassName="lg:w-3 w-6" label="Cancel" onClick={() => history.push("/style-guides")} />
            </div>
        </>
    );
};

export default StyleGuideForm;
